<template>
    <div class="catalogue" >
        <div class="header-tool">
            <div class="header-tool-info">
                <Breadcrumb>
                    <BreadcrumbItem to="/host/index/home">首页</BreadcrumbItem>
                    <BreadcrumbItem>浏览量统计</BreadcrumbItem>
                </Breadcrumb>
                <div class="header-tool-title">浏览量统计</div>

                <div style="display:flex;margin-top:15px" v-if="company.isEnableViewRole">
                    <el-input placeholder="请输入搜索的内容" size="small" class="marLeft" style="width: 200px;"
                        v-model="searchField" clearable>
                    </el-input>
                    <el-button type="primary" size="small" @click="searchChick()" class="marLeft">搜索</el-button>
                </div>
            </div>
            <div class="header-tool-box" v-if="company.isEnableViewRole">
                <div class="htb-item" @click="hostExcelExportBackChange">
                    <i class="icon iconfont icon-downLoad2"></i>
                    <span>导出</span>
                </div>
            </div>
        </div>
        <div class="header-tabs" v-if="company.isEnableViewRole">
            <Tabs :animated="false" @on-click="switchBrand" v-model="showTabs">
                <TabPane :label="showTabs == '0' ? '全部产品' + '(' + totalCount + ')' : '全部产品'" name="0">
                </TabPane>
                <TabPane :label="showTabs == '1' ? '投票产品' + '(' + totalCount + ')' : '投票产品'" name="1">
                </TabPane>
            </Tabs>
        </div>

        <div v-if="!company.isEnableViewRole">
            <el-empty description="暂无权限"></el-empty>
        </div>
        <div class="layout-content" style="background: transparent;" v-else>
            <!-- <div v-if="list.length"> -->
            <div v-if="list.length">
                <Table :columns="columns" :loading="loading" :data="list">
                    <template slot-scope="{ row }" slot="name">{{ row.name }}</template>
                    <template slot-scope="{ row }" slot="tag">{{ row.tagName }}</template>
                    <template slot-scope="{ row }" slot="type">
                        {{ row.category ? row.category : '' }}
                    </template>
                    <template slot-scope="{ row }" slot="time">{{ row.inTime | dateFormat }}</template>

                    <template slot-scope="{ row }" slot="liang">
                        <!-- {{ row.viewCount }} -->
                        <span v-if="showTabs == 0">{{ row.viewCount }} </span>
                        <span v-else>{{ row.countNum }} </span>

                    </template>
                    <template slot-scope="{ row }" slot="isdeal">
                        <div>
                            <span class="lookClass" style="cursor:pointer" @click="rejectP(row, '0')">查看</span>
                        </div>


                    </template>
                </Table>
                <div class="my-page" v-if="totalCount > pageSize" style="margin: 20px;text-align: center;">
                    <Page show-total show-elevator :page-size="pageSize" :current="pageIndex" :total="totalCount"
                        @on-change="changePage" @on-page-size-change="changePageSize" />
                </div>
            </div>
            <div class="u-empty" v-else>暂无数据</div>
        </div>

        <iModal :title="modelTitle" v-model="rejectModel" class-name="vertical-center-modal" width="60%"
            :mask-closable="false">
            <div>
                <Table min-height="500" :columns="columns1" :loading="loading1" :data="tableList">
                    <template slot-scope="{ row }" slot="name">{{ row.name }}</template>
                    <template slot-scope="{ row }" slot="comm">{{ row.compName }}</template>

                    <template slot-scope="{ row }" slot="job">
                        {{ row.jobTitle ? row.jobTitle : '' }}
                    </template>
                    <template slot-scope="{ row }" slot="tel">{{ row.phoneNumber }}</template>
                    <template slot-scope="{ row }" slot="email">{{ row.email }}</template>
                    <template slot-scope="{ row }" slot="adress">
                        <template v-if="row.province">{{ row.province }} </template>
                        <template v-if="row.city">{{ row.city }}</template>
                        <template v-if="row.county">{{ row.county }} </template>
                    </template>
                    <template slot-scope="{ row }" slot="dizhi">
                        <!-- {{ row.fromType }} -->
                        <div v-if="showTabs == 0">
                            <template v-if="row.fromType == 'wechat'">小程序 </template>
                            <template v-if="row.fromType == 'pcen'">英文官网 </template>
                        </div>
                        <div v-else>{{ row.ips }}</div>
                    </template>
                    <template slot-scope="{ row }" slot="time">{{ row.inTime ? (row.inTime | dateFormat) : '' }}</template>
                </Table>

                <!-- <div class="my-page" v-if="totalCountLog > pageSizeLog" style="margin: 20px;text-align: center;">
                    <Page show-total show-elevator :page-size="pageSizeLog" :current="pageIndexLog" :total="totalCountLog"
                        @on-change="changePageLog" @on-page-size-change="changePageSizeLog" />
                </div> -->
            </div>

            <!-- <div slot="footer">
                <Button type="primary" @click="rejectModel = false">确定</Button>
            </div> -->
        </iModal>
        <div class="catalogue-content"></div>

    </div>
</template>
  
<script>
import { mapGetters, mapActions } from 'vuex'

export default {
    data () {
        return {
            newsAudit: "0",
            productTypeOptions: [
                {
                    value: '选项1',
                    label: '黄金糕',
                },
            ],
            productTypeValue: '',

            modalDetail: false,
            loading: false,
            loading1: false,

            editBrand: false,
            editBrandnfo: null,
            editTopic: false,
            editTopicnfo: null,
            search: '',
            editInfo: null,
            pageSize: 20,
            pageIndex: 1,
            totalCount: 0,
            pageSizeLog: 99999,
            pageIndexLog: 1,
            totalCountLog: 0,
            columns: [

                {
                    title: '产品名称',
                    slot: 'name',
                    align: 'center',
                },
                {
                    title: '标签',
                    slot: 'tag',
                    align: 'center',
                },
                {
                    title: '产品类别',
                    slot: 'type',
                    align: 'center',
                },
                {
                    title: '提交时间',
                    slot: 'time',
                    align: 'center',
                },
                {
                    title: '浏览量',
                    slot: 'liang',
                    align: 'center',
                },
                {
                    title: '操作',
                    slot: 'isdeal',
                    align: 'center',
                },
            ],

            columns1: [
                {
                    title: '姓名',
                    slot: 'name',
                    align: 'center',
                },
                {
                    title: '公司',
                    slot: 'comm',
                    align: 'center',
                },
                {
                    title: '职务',
                    slot: 'job',
                    align: 'center',
                },
                {
                    title: '手机',
                    slot: 'tel',
                    align: 'center',
                },
                {
                    title: '邮箱',
                    slot: 'email',
                    align: 'center',
                },
                {
                    title: '地区',
                    slot: 'adress',
                    align: 'center',
                },
                {
                    title: '来源',
                    slot: 'dizhi',
                    align: 'center',
                },
                {
                    title: '浏览时间',
                    slot: 'time',
                    align: 'center',
                },
            ],
            oppTime: [],
            searchField: '',
            list: [],
            selection: [], // 选中项目
            addShow: false,
            rejectModel: false,
            modelTitle: '',
            rowUser: {},
            showTabs: '0',
            PoptipTitle: '',
            option: {},
            stateInit: '',
            rejectValue: '',
            form: {
                category: [], // 展品分类
            },
            type: [],
            contactsList: [],
            tableList: [],
            idCategory: '',
            proIdType: "fcb459d0-9565-413b-832d-f25bba4c3567",
            statusProType: ['wait'],
            excelOpt: {},
        }
    },
    components: {
        // exhibitionCarYes,
        // exhibitionCarNo
    },
    computed: {
        ...mapGetters({
            exhibition: 'loginModule/getExhibition',
            exhibitionInfo: 'hostSetModule/getHostExhibition',
            hostExhibition: 'hostSetModule/getHostExhibition',

            company: "loginModule/getCompany"

        }),
    },
    created () {
        // console.log(this.company);
        document.title = '中国国际医疗器械博览会 - 产品审核'
        this.init()
    },
    methods: {
        ...mapActions({
            getHostBuySupply: 'hostSetModule/getHostBuySupply',
            putHostUpdateState: 'hostSetModule/putHostUpdateState',
            getHostCallingAgain: 'hostSetModule/getHostCallingAgain',
            getBuyExport: 'hostSetModule/getBuyExport',
            //   商机
            busOppNewRealeaseGetPageList:
                'hostSetModule/busOppNewRealeaseGetPageList',
            getProductByGroupId: 'categoryModule/getProductByGroupId', // 获取  产品类别
            busOppNewRealeasePutUpdate: 'hostSetModule/busOppNewRealeasePutUpdate', // 修改
            busOppNewRealeaseExcelExportHost:
                'hostSetModule/busOppNewRealeaseExcelExportHost',
            newRealeaseSetIsShow: 'hostSetModule/newRealeaseSetIsShow',
            getByCompId: 'hostSetModule/getByCompId',
            getAllBindsById: 'hostSetModule/getAllBindsById',

            getAuditLogPass: 'hostSetModule/getAuditLogPass',
            getAuditLogPut: 'hostSetModule/getAuditLogPut',
            postProductTagCount: 'hostSetModule/postProductTagCount',

            postExcelExportTagCount: 'hostSetModule/postExcelExportTagCount',
            postExcelExportWechatProduct: 'hostSetModule/postExcelExportWechatProduct',
            postProductTagAuditLogPage: 'hostSetModule/postProductTagAuditLogPage',

            getProduct: "productModule/getProduct",
            getProductLog: "productModule/getProductLog",
            postProductTagCountTou: "productModule/postProductTagCountTou",//投票产品查询公司所有浏览量
            postGetViewLogByProductTou: "productModule/postGetViewLogByProductTou",//投票产品浏览记录查询
            postExcelExportProductView: "productModule/postExcelExportProductView",// 浏览量 导出 
            postExcelGetAllByCompIdTou: "productModule/postExcelGetAllByCompIdTou",//投票产品导出


        }),
        async switchBrand (name) {
            this.pageIndex = 1
            this.init()
        },

        initStatus () {
            this.pageIndex = 1
            if (this.newsAudit == 0) {
                this.statusProType = ['wait']
            }
            if (this.newsAudit == 1) {
                this.statusProType = ['pass', 'notpass']
            }
            this.init()

        },
        searchChick () {
            this.init()
            //     this.startDateStr = this.formatDate(this.oppTime[0])
            //   this.endDateStr = this.formatDate(this.oppTime[1])
        },
        // 转换日期格式
        formatDate (dateTime) {
            let date = new Date(dateTime)
            let YY = date.getFullYear() + '-'
            let MM =
                (date.getMonth() + 1 < 10
                    ? '0' + (date.getMonth() + 1)
                    : date.getMonth() + 1) + '-'
            let DD = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
            let hh =
                (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
            let mm =
                (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) +
                ':'
            let ss =
                date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
            //    return YY + MM + DD + " " + hh + mm + ss;
            return YY + MM + DD
        },

        async init () {
            let pushList1 = [
                {
                    type: 1,
                    Wheres: {
                        WhereOperator: 6,
                        Label: 'name',
                        Value: `%${this.searchField || ''}%`,
                    },
                },
            ]
            let opt1 = {
                compId: this.company.id,
                pageSize: this.pageSize,
                pageIndex: this.pageIndex,
                Wheres: {
                    type: 0,
                    Wheres: {
                        WhereGroupOperator: 0,
                        Predicates: pushList1,
                    },
                },
            }
            this.loading = true
            let proData = null


            this.excelOpt = opt1
            if (this.showTabs == 0) {
                proData = await this.getProduct(opt1);
            } else {
                proData = await this.postProductTagCountTou(opt1);
            }

            if (proData) {
                this.loading = false
                let resList = proData.items
                this.pageSize = proData.pageSize
                this.pageIndex = proData.pageIndex
                this.totalCount = proData.totalCount
                resList.forEach((e) => {
                    if (e.category) {
                        const category = JSON.parse(e.category)
                        const categoryArr = []
                        if (category) {
                            if (category.Value) {
                                categoryArr.push(category.Value)
                                if (category.List[0]) {
                                    categoryArr.push(category.List[0].Value)
                                    if (category.List[0].list) {
                                        categoryArr.push(category.List[0].list[0].Value)
                                    }
                                }

                                e.category = categoryArr.join('/')
                            }
                        }
                    }
                    if (e.tag) {
                        const tag = JSON.parse(e.tag)
                        const tagArr = []
                        tag.map(k => {
                            if (k) {
                                if (k.Value) {
                                    tagArr.push(k.Value)
                                    if (k.List[0]) {
                                        tagArr.push(k.List[0].Value)
                                    }
                                    e.tagName = tagArr.join('/')
                                }
                            }
                        })

                    }
                })
                this.list = resList
                console.log(this.list, '[][][][][][][][]')
            } else {
                this.loading = false
            }
        },

        async setAllAudit () {
            const reqList = []
            if (!this.selection.length) return
            this.selection.forEach((c) => {
                reqList.push(c.joinId)
            })
            const bool = await this.setOneStepAudit({
                joinIds: reqList,
            })
            if (bool && bool.successed) {
                this.$Message.success('操作成功')
                this.init()
            } else {
                this.$Message.error('操作失败，请重新尝试')
            }
        },
        changePage (e) {
            this.pageIndex = e
            this.init()
        },
        changePageLog (e) {
            this.pageIndexLog = e
            this.rejectP()
        },
        changePageSize (e) {
            this.pageSize = e
            this.init()
        },
        changePageSizeLog (e) {
            this.pageSizeLog = e
            this.rejectP()
        },
        edit (item) {
            this.editInfo = item
        },
        searchPro () {
            this.pageIndex = 1
            this.init()
        },
        changeEvent (selection) {
            this.selection = selection
        },
        async rejectP (row, index) {
            let opt = {
                by: row.id,
                pageSize: this.pageSizeLog,
                pageIndex: this.pageIndexLog
            }
            let opt1 = {
                productId: row.id,
                pageSize: this.pageSizeLog,
                pageIndex: this.pageIndexLog
            }
            let proData = null
            if (this.showTabs == 0) {
                proData = await this.getProductLog(opt)
            } else {
                proData = await this.postGetViewLogByProductTou(opt1)
            }

            if (proData) {
                this.loading1 = false
                let list = proData.items
                this.pageSizeLog = proData.pageSize
                this.pageIndexLog = proData.pageIndex
                this.totalCountLog = proData.totalCount

                this.tableList = list
                console.log(this.tableList, 'tableList')
            } else {
                this.loading1 = false
            }
            this.rejectValue = ''
            this.rowUser = row
            this.modelTitle = row.name
            this.rejectModel = true
            //   }
        },

        // 驳回确定按钮
        async handleSubmitReject () {
            if (!this.rejectValue) {
                this.$Message.warning('驳回理由不能为空！')
                return
            }
            const option = {
                // id: this.rowUser.id,
                id: this.rowUser.id,
                setValues: {
                    Remark: this.rejectValue,
                    AuditStatus: 'notpass',
                },
            }
            let bool = await this.getAuditLogPut(option)
            if (bool && bool.successed) {
                this.rejectModel = false
                this.$Message.success('操作成功')
                this.init()
            } else {
                this.$Message.error('操作失败，请重新尝试')
            }
            //   }
        },

        // 获取产品类别
        changeCategory (val) {
            let category = this.form.category
            if (val) {
                category = this.form.category = val
            }
            let data = null
            this.type.forEach((c) => {
                if (category[0] && c.name === category[0]) {
                    this.idCategory = c.id
                    data = {
                        Id: c.id,
                        Value: c.name,
                        List: [],
                    }
                    if (c.list && c.list.length && category[1]) {
                        c.list.forEach((v) => {
                            if (v.name === category[1]) {
                                this.idCategory = v.id
                                data.List[0] = {
                                    Id: v.id,
                                    Value: v.name,
                                }
                                if (v.list && v.list.length && category[2]) {
                                    v.list.forEach((j) => {
                                        if (j.name === category[2]) {
                                            this.idCategory = j.id
                                            data.List[0].list = [
                                                {
                                                    Id: j.id,
                                                    Value: j.name,
                                                    Remark: j.tag,
                                                },
                                            ]
                                        }
                                    })
                                }
                            }
                        })
                    }
                }
            })
            console.log(this.idCategory)
            return data
        },

        // 修改展品显示、屏蔽
        async showToggle (item) {
            const bool = !!item.isShow
            let result = await this.newRealeaseSetIsShow({
                id: item.id,
                setValues: {
                    IsShow: bool,
                },
            })
            if (result.successed) {
                this.$Message.success('修改成功')
                this.init()
            } else {
                this.$Message.error('修改失败，请重新尝试')
            }
        },

        hostExcelExportBackChange () {
            if (this.showTabs == '0') {
                this.hostExcelExportBackWechat()
                return
            } else {
                this.hostExcelExportBack()
            }
        },

        // 展商导出
        async hostExcelExportBack () {

            let res = await this.postExcelGetAllByCompIdTou(this.excelOpt)
            let filename = "投票产品导出.xlsx";
            const blob = new Blob([res], { type: 'application/vnd.ms-excel' }); // 构造一个blob对象来处理数据，并设置文件类型
            if (window.navigator.msSaveOrOpenBlob) {
                // 兼容IE10
                navigator.msSaveBlob(blob, filename);
            } else {
                const href = URL.createObjectURL(blob); // 创建新的URL表示指定的blob对象
                const a = document.createElement("a");
                a.style.display = "none";
                a.href = href; // 指定下载链接
                a.download = filename; // 指定下载文件名
                a.click();
                URL.revokeObjectURL(a.href); // 释放URL对象
            }
            this.$Message.success("导出成功，耐心等待");

        },
        async hostExcelExportBackWechat () {

            let res = await this.postExcelExportProductView(this.excelOpt)
            let filename = "全部产品导出.xlsx";
            const blob = new Blob([res], { type: 'application/vnd.ms-excel' }); // 构造一个blob对象来处理数据，并设置文件类型
            if (window.navigator.msSaveOrOpenBlob) {
                // 兼容IE10
                navigator.msSaveBlob(blob, filename);
            } else {
                const href = URL.createObjectURL(blob); // 创建新的URL表示指定的blob对象
                const a = document.createElement("a");
                a.style.display = "none";
                a.href = href; // 指定下载链接
                a.download = filename; // 指定下载文件名
                a.click();
                URL.revokeObjectURL(a.href); // 释放URL对象
            }
            this.$Message.success("导出成功，耐心等待");

        },
    },
}
</script>
  
<style scoped lang="scss">
.catalogue {
    .header-tool {
        min-height: 90px;
    }

    &-content {
        min-width: 1000px;
        margin: 24px;
        padding: 40px;
        min-height: 500px;
        padding-bottom: 190px;
    }
}

.cib {
    min-width: 1000px;
    margin: 30px;
    padding: 40px;
    min-height: 500px;
    background: #fff;
    padding-bottom: 190px;
}

.spanClass {
    margin-left: 4px;
    margin-right: 4px;
}

.deleteClass {
    color: #f78989;
    // cursor:pointer;
}

.lookClass {
    color: #1890ff;
    cursor: pointer;
}

.marLeft {
    margin-left: 15px;
}
</style>
  